import { useEffect, useState } from 'react';

import { AxiosResponse } from 'axios';
import { HTTP_OPTIONS } from '@silverfort-nodelibs/common/utils/consts';
import { IncidentsSeverityOverview } from '../types/Incidents';
import { httpGet } from '../../../../components/utils';

interface Params {
    lastActivityFilterInDays: number;
}

const useGetIncidentsSeverityOverview = ({ lastActivityFilterInDays }: Params) => {
    const [data, setData] = useState<IncidentsSeverityOverview>();
    const [isFetching, setIsFetching] = useState(false);
    const [error, setError] = useState<string>();

    useEffect(() => {
        const fetchIncidentsSeverityOverview = async () => {
            setIsFetching(true);
            setError(undefined);

            try {
                const response = (await httpGet('/incidents/overview/severity', {
                    [HTTP_OPTIONS.REQ_OPTIONS]: {
                        params: {
                            lastActivityFilterInDays
                        }
                    }
                })) as unknown as AxiosResponse<IncidentsSeverityOverview>;

                setData(response.data);
            } catch (err) {
                setError('Failed to get incidents severity overview from server');
            }
            setIsFetching(false);
        };

        fetchIncidentsSeverityOverview();
    }, [lastActivityFilterInDays]);

    return { data, isFetching, error };
};

export default useGetIncidentsSeverityOverview;
